module.exports = __webpack_public_path__ + "img/logo 1.4af2d01f.svg";